/**
 * Деньги одинаково во всём разделе логистики: рубли, запятая, два знака.
 *
 * Вынесено из экрана отчётов, потому что тот же формат нужен окну импорта
 * выплат, а окно импортируется экраном: общий модуль вместо кольца импортов.
 */
export function formatMoney(minor: string): string {
  const value = Number(BigInt(minor)) / 100;
  return `${value.toFixed(2).replace('.', ',')} ₽`;
}
